export default "__VITE_ASSET__BSBC3GOs__"